import { CanDeactivateFn } from '@angular/router';
import { OrderProcessingComponent } from '../../user/order-processing/order-processing.component';
import { firstValueFrom } from 'rxjs';
import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { GenericAlertPopupComponent } from '../../shared/generic-alert-popup/generic-alert-popup.component';

export const orderProcessingGuard: CanDeactivateFn<OrderProcessingComponent> = async (component, currentRoute, currentState, nextState) => {
	const dialog = inject(MatDialog);

	if (!component.isOrderProcessing()) {
		return true;
	}

	const leave = await firstValueFrom(dialog.open(GenericAlertPopupComponent, {
		width: '30%',
		data: {
			title: 'orders.warning_leave',
			description: 'orders.warning_leave_description',
			acceptBtnText: 'general.leave',
			dismissBtnText: 'general.cancel',
			btnColor: 'primary'
		}
	}).afterClosed());

	return leave;
};
